import type { TableDropdownOption } from './tableToolbar.types';

export const buildStringCountMap = <TRow>(
  rows: readonly TRow[],
  resolveValue: (row: TRow) => string | null | undefined,
): Partial<Record<string, number>> => {
  const counts: Partial<Record<string, number>> = {};

  rows.forEach((row) => {
    const value = resolveValue(row)?.trim();
    if (!value) return;
    counts[value] = (counts[value] ?? 0) + 1;
  });

  return counts;
};

export const buildStringArrayCountMap = <TRow>(
  rows: readonly TRow[],
  resolveValues: (row: TRow) => readonly string[] | null | undefined,
): Partial<Record<string, number>> => {
  const counts: Partial<Record<string, number>> = {};

  rows.forEach((row) => {
    const values = new Set(
      (resolveValues(row) ?? []).map((value) => value.trim()).filter((value) => value.length > 0),
    );
    values.forEach((value) => {
      counts[value] = (counts[value] ?? 0) + 1;
    });
  });

  return counts;
};

export const buildCountedDropdownOptions = <TOption extends TableDropdownOption>(
  options: readonly TOption[],
  counts: Partial<Record<string, number>>,
): Array<TOption & { count: number }> =>
  options.map((option) => ({
    ...option,
    count: counts[option.value] ?? 0,
  }));
